import Link from '../OC/oc-link';

export default Link;
